module.exports = __webpack_public_path__ + "images/15-01_4b5d4c7d.png";